"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languageMsg = void 0;
const languageMsg = exports.languageMsg = {
  NAVIGATION_EMPTY: 'There is no navigation items for this user, please configure.'
};